import React from 'react';
import { MapPin, Phone, Mail, Facebook, Instagram, ExternalLink, Youtube } from 'lucide-react';

const RADIO_LISCIO_LOGO  = "https://customer-assets.emergentagent.com/job_liscio-moderno/artifacts/jukq3hwm_1200x600wa.png";
const GIO_FANTINI_GIF    = "https://customer-assets.emergentagent.com/job_3a008eb2-6f58-4bf6-b16e-78d189a6aa15/artifacts/6uru6mnl_GIO-FANTINI.gif";
const LP_LOGO            = "https://customer-assets.emergentagent.com/job_3a008eb2-6f58-4bf6-b16e-78d189a6aa15/artifacts/lymh6mbi_LA%20PESCHIERA%20CLUB%20WHITE%20E%20STREET.png";
const PRIMANTENNA_LOGO   = "https://customer-assets.emergentagent.com/job_liscio-moderno/artifacts/owdzdzkw_logo_primantenna_retina.png";

export default function Footer() {
  const year = new Date().getFullYear();
  const mapQuery = encodeURIComponent("Via Q. Sella 65, Valdengo, BI, 13900 Italia");

  return (
    <footer id="contatti" data-testid="footer" className="footer-dark pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-8">

        {/* Sponsors row */}
        <div className="flex flex-wrap justify-center items-center gap-10 md:gap-16 mb-12 pb-10 border-b border-white/10">
          <div className="text-center">
            <p className="text-xs text-gray-500 uppercase tracking-widest font-manrope mb-3">Partner ufficiale</p>
            <img
              src={RADIO_LISCIO_LOGO}
              alt="Radio Liscio"
              data-testid="radio-liscio-logo"
              className="h-14 object-contain"
              style={{ filter: 'drop-shadow(0 0 12px rgba(255,140,0,0.3))' }}
            />
          </div>
          <div className="text-center">
            <p className="text-xs text-gray-500 uppercase tracking-widest font-manrope mb-3">Partner ufficiale</p>
            <img
              src={PRIMANTENNA_LOGO}
              alt="Primantenna"
              data-testid="primantenna-logo"
              className="h-14 object-contain"
              style={{ filter: 'drop-shadow(0 0 12px rgba(255,200,0,0.25))' }}
            />
          </div>
          <div className="text-center">
            <p className="text-xs text-gray-500 uppercase tracking-widest font-manrope mb-3">Powered by</p>
            <img
              src="/api/uploads/powered_by_gio.png"
              alt="Gio Fantini"
              data-testid="gio-fantini-logo"
              className="h-16 object-contain"
            />
          </div>
        </div>

        {/* Main footer grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          {/* Club info */}
          <div>
            <img src={LP_LOGO} alt="La Peschiera Club" className="h-16 object-contain mb-4" />
            <p className="text-gray-400 text-base leading-relaxed font-manrope">
              La Peschiera Club di Valdengo (BI)<br />
              Ospita le migliori Band, Dj set e Concerti<br />
              In Collaborazione Con Radio &amp; Tv.
            </p>
          </div>

          {/* Contacts */}
          <div>
            <h4 className="font-playfair text-xl font-bold text-white mb-5">Contatti</h4>
            <div className="space-y-4">
              <a
                href="https://maps.google.com/maps?q=Via+Q.+Sella+65+Valdengo+BI"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-address"
                className="flex items-start gap-3 text-gray-400 hover:text-gold transition-colors group"
              >
                <MapPin size={20} className="text-gold mt-0.5 shrink-0" />
                <span className="text-base">Via Q. Sella 65,<br />Valdengo (BI) 13900</span>
              </a>
              <a
                href="tel:+393518892962"
                data-testid="footer-phone"
                className="flex items-center gap-3 text-gray-400 hover:text-gold transition-colors"
              >
                <Phone size={20} className="text-gold shrink-0" />
                <span className="text-base">351 889 2962</span>
              </a>
              <a
                href="mailto:dancinglapeschiera@gmail.com"
                data-testid="footer-email"
                className="flex items-center gap-3 text-gray-400 hover:text-gold transition-colors"
              >
                <Mail size={20} className="text-gold shrink-0" />
                <span className="text-base">dancinglapeschiera@gmail.com</span>
              </a>
            </div>

            {/* Social */}
            <div className="flex gap-4 mt-6">
              <a
                href="https://www.facebook.com/lapeschieradisco.it/?locale=it_IT"
                target="_blank" rel="noopener noreferrer"
                data-testid="social-facebook"
                className="w-14 h-14 rounded-full flex items-center justify-center transition-all"
                style={{ border: '2px solid rgba(201,168,76,0.5)', color: 'var(--color-gold)', boxShadow: '0 0 12px rgba(201,168,76,0.15)' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor='#c9a84c'; e.currentTarget.style.boxShadow='0 0 20px rgba(201,168,76,0.4)'; e.currentTarget.style.background='rgba(201,168,76,0.1)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor='rgba(201,168,76,0.5)'; e.currentTarget.style.boxShadow='0 0 12px rgba(201,168,76,0.15)'; e.currentTarget.style.background='transparent'; }}
                aria-label="Facebook"
              >
                <Facebook size={22} />
              </a>
              <a
                href="https://www.instagram.com/lapeschieradisco.it/"
                target="_blank" rel="noopener noreferrer"
                data-testid="social-instagram"
                className="w-14 h-14 rounded-full flex items-center justify-center transition-all"
                style={{ border: '2px solid rgba(201,168,76,0.5)', color: 'var(--color-gold)', boxShadow: '0 0 12px rgba(201,168,76,0.15)' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor='#c9a84c'; e.currentTarget.style.boxShadow='0 0 20px rgba(201,168,76,0.4)'; e.currentTarget.style.background='rgba(201,168,76,0.1)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor='rgba(201,168,76,0.5)'; e.currentTarget.style.boxShadow='0 0 12px rgba(201,168,76,0.15)'; e.currentTarget.style.background='transparent'; }}
                aria-label="Instagram"
              >
                <Instagram size={22} />
              </a>
              <a
                href="https://www.youtube.com/@RADIOLISCIO"
                target="_blank" rel="noopener noreferrer"
                data-testid="social-youtube"
                className="w-14 h-14 rounded-full flex items-center justify-center transition-all"
                style={{ border: '2px solid rgba(201,168,76,0.5)', color: 'var(--color-gold)', boxShadow: '0 0 12px rgba(201,168,76,0.15)' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor='#c9a84c'; e.currentTarget.style.boxShadow='0 0 20px rgba(201,168,76,0.4)'; e.currentTarget.style.background='rgba(201,168,76,0.1)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor='rgba(201,168,76,0.5)'; e.currentTarget.style.boxShadow='0 0 12px rgba(201,168,76,0.15)'; e.currentTarget.style.background='transparent'; }}
                aria-label="YouTube"
              >
                <Youtube size={22} />
              </a>
            </div>
          </div>

          {/* Map */}
          <div>
            <h4 className="font-playfair text-xl font-bold text-white mb-5">Come raggiungerci</h4>
            <div
              className="rounded-xl overflow-hidden border border-white/10"
              data-testid="footer-map"
              style={{ height: '200px' }}
            >
              <iframe
                title="La Peschiera Club - Mappa"
                src={`https://www.openstreetmap.org/export/embed.html?bbox=8.25%2C45.52%2C8.27%2C45.54&layer=mapnik&marker=45.53%2C8.26`}
                width="100%"
                height="100%"
                style={{ border: 0, filter: 'invert(90%) hue-rotate(180deg) saturate(0.7)' }}
                loading="lazy"
              />
            </div>
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${mapQuery}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="map-directions"
              className="inline-flex items-center gap-2 text-sm text-gold hover:text-gold-hover mt-3 font-manrope font-600"
            >
              <ExternalLink size={14} /> Apri in Google Maps
            </a>
          </div>
        </div>

        {/* Neon line */}
        <div className="neon-line mb-6" />

        {/* Bottom bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-gray-500 font-manrope">
          <p>&copy; {year} La Peschiera Club &mdash; Valdengo (BI). Tutti i diritti riservati.</p>
          <div className="flex items-center gap-4">
            <a href="/cookie-policy" className="hover:text-gold transition-colors" data-testid="footer-cookie-link">Cookie Policy</a>
            <span className="text-gray-700">|</span>
            <a href="/termini" className="hover:text-gold transition-colors" data-testid="footer-terms-link">Termini e Condizioni</a>
            <span className="text-gray-700">|</span>
            <p className="flex items-center gap-2">
              Powered by{' '}
              <img src="/api/uploads/powered_by_gio.png" alt="Gio Fantini" className="h-6 object-contain" />
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
